/**
 * プリセット一覧ページ コンテナ
 */

import {
  useDeletePreset,
  usePresets,
  useTogglePresetActive,
} from "hooks/use-preset-api";
import type React from "react";
import { useCallback } from "react";
import { PresetsPage } from "routes/settings/PresetsPage/PresetsPage";

/**
 * プリセット一覧ページのコンテナコンポーネント
 * @return {JSX.Element} PresetsPage コンテナ
 */
const PresetsPageContainer: React.FC = () => {
  const { presets, loading, error, refetch } = usePresets();
  const { toggleActive, loading: isToggling } = useTogglePresetActive();
  const { deletePreset, loading: isDeleting } = useDeletePreset();

  const handleToggleActive = useCallback(
    async (presetId: string) => {
      await toggleActive(presetId);
      await refetch();
    },
    [toggleActive, refetch],
  );

  const handleDelete = useCallback(
    async (presetId: string) => {
      await deletePreset(presetId);
      await refetch();
    },
    [deletePreset, refetch],
  );

  return (
    <PresetsPage
      presets={presets}
      loading={loading}
      error={error ? { message: error.message } : null}
      onToggleActive={handleToggleActive}
      onDelete={handleDelete}
      isToggling={isToggling}
      isDeleting={isDeleting}
    />
  );
};

export default PresetsPageContainer;
